module.exports = __webpack_public_path__ + "static/media/c9bannerModulF_small.ca8e5cb6.jpg";